const OrganisationLayout = ({ children }) => {
  return <>{children}</>;
};

export default OrganisationLayout;
